import { type FC } from "react";
import { type RectangleProps } from "recharts";

import { DatasetChart, type IConditionCombination } from "./DatasetChart.js";

export interface ICustomBarProps {
  getSelectionCount: (fields: string[]) => number;
  getSelectedRawData: (data) => { key: string; value: number }[];
  getSelectionYPosition: (value: number) => number;
}

interface IInjectedCustomBarProps extends ICustomBarProps, Omit<RectangleProps, "name">, IConditionCombination {}

/**
 * Custom bar for bar chart.
 *
 * created on 2/16/2018
 */
const CustomBar: FC<ICustomBarProps> = (props: IInjectedCustomBarProps) => {
  const { fill, x, y, width, height } = props; // injected via RectangleProps
  const { fields } = props; // injected via IConditionCombination

  if (isNaN(height) || isNaN(y)) {
    return null;
  }

  // const fullySelected: boolean = this.allSelected(this.props.chartSelection, fields);
  // we calculate the amount of items corresponding to the bar so that we can show visually the proportion of the bar that is actually selected (from the table)
  const selectionCount: number = props.getSelectionCount(fields);
  // add a bar layer that shows the proportion of selected samples from the table:  { selectionCount > 0 && <rect width={width} height={height / fields.length * selectionCount} fill={DatasetChart.COLOR_SELECTION} x={x} y={y}  /> }
  const selectionProps: any =
    selectionCount === 0
      ? {}
      : {
          stroke: DatasetChart.COLOR_SELECTION,
          strokeWidth: 3,
        };

  // infer the position of the selected raw data from the side table
  const selectedRawData: { key; value }[] = props.getSelectedRawData((props as any).payload);

  return (
    <g>
      <rect
        width={width}
        height={height < 0 ? -height : height}
        fill={fill}
        x={x}
        y={height < 0 ? y + height : y}
        {...selectionProps}
        cursor="pointer"
      />
      {selectedRawData.map((rawData: { key; value }, index: number) => (
        <circle
          cx={x + width / 2}
          cy={props.getSelectionYPosition(rawData.value)}
          r={6}
          key={`chart_sel_dot_${index}`}
          stroke={DatasetChart.TABLE_COLOR_SELECTION}
          strokeWidth={2}
          fill={"transparent"}
        >
          <title>{rawData.value}</title>
        </circle>
      ))}
    </g>
  );
};

export default CustomBar;
